export const placeholder = "https://via.placeholder.com/414"
export const links = {
  employees: "https://www.kvadrat.se/aktuellt/kvadrat-sundsvall-forstarker-med-ny-affarsutvecklare/",
  consultants: "https://www.kvadrat.se/anlita-kvadrat/hitta-konsult/?q=&l=sundsvall#results",
}
